package com.pincer.core.contracts

import com.pincer.core.model.Device
import com.pincer.core.model.tree.Pincer
import com.pincer.core.model.patches.PincerPatch

/*
Here we define the foundational relationship between the server and client.
Since the Pincer class is so rich, we don't need a huge number of endpoints.

The first block of methods are all about the device and principal.
Once that IAM stuff is sorted, everything else happens in terms of the Pincer model.

GET versions work with pids and sids.
 - The 'pid' is the "primary id" or "pincer id" (12 letters).
 - The 'sid' if the "secondary id" or "serial id" to show the version (numeric).

To create a new Pincer you actually fork from a template.
There are low-level generic ones to get people started, but from then on they would version their own.
After forking, you patch to make changes to the result.
*/

interface BaseContract {
    suspend fun device(): Device
    suspend fun principalAnonymous(jwt: String, locale: String?, zone: String?): String
    suspend fun principalTriggerCode(jwt: String, credential: String)
    suspend fun principalConfirmCode(jwt: String, credential: String, code: String, locale: String?, zone: String?): String
    suspend fun principalLogout(jwt: String, allDevices: Boolean)
    suspend fun principalWhoAmI(jwt: String): String

    suspend fun get(jwt: String, pid: String): Pincer
    suspend fun getAt(jwt: String, pid: String, sid: Long): Pincer
    suspend fun getSince(jwt: String, pid: String, sid: Long): PincerPatch
    suspend fun fork(jwt: String, pid: String): String
    suspend fun patch(jwt: String, pid: String, sid: Long, patch: PincerPatch): PincerPatch
}

// 1678798465 : Tuesday, 14-Mar-23 12:04:43 UTC
val TERMS_LAST_CHANGED_AT_MILLIS = 1678798465 * 1000L
val TEMPLATE_PID = "BBBBBBBBBBBB"
val PERSONAL_PID = "CCCCCCCCCCCC"
